import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { BalanceAllEntity, BalanceEntity } from './balance.entity'

export class BrokerBalancesRepository extends BaseRepository<BalanceEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.brokerApiUrl + '/' + 'balances', token, cache)
    }

    async getAllBalance(): Promise<BalanceAllEntity> {
        const { json, statusCode, message } = await this.request.get(this.config.brokerApiUrl + '/balances/total?token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
